export const checkIsDateInPastOrNow = (date: string) => {
  const givenDate = new Date(date);
  const currentDate = new Date();
  return givenDate.getTime() <= currentDate.getTime();
};
